var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget-settings-item',{attrs:{"title":_vm.title,"optional":""}},[_c('c-storages-field',_vm._g({attrs:{"label":_vm.$t('settings.serverStorage'),"disabled":_vm.disabled,"help-text":_vm.helpText},model:{value:(_vm.storages),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"storages"}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }